<script>
  import { onMount } from 'svelte';

  export let message = "Loading"; // Default value is "Loading"

  let dots = '';

  onMount(() => {
    

    const dotsInterval = setInterval(() => {
      dots += '.';
      if (dots.length > 3) dots = '';
    }, 500);

    return () => {
      clearInterval(dotsInterval);
    };
  });
</script>


<div class="flex items-center space-x-2">
  <div>
    {message}{dots}
  </div>
</div>

